import { apiClient } from "../api";
import { API_BASE_URL, API_PREFIX } from "../api/constants";

/**
 * Servicio de cursos (crear curso, crear sección)
 * API: POST /cursos/{idCurso}/secciones con nombre, orden, estado y archivo PDF.
 */

export const createCurso = async (payload) => {
  const { data } = await apiClient.post("cursos", payload);
  return data;
};

export const getCursos = async (filters = {}) => {
  const params = {};
  if (filters?.Estado !== undefined && filters?.Estado !== null && filters?.Estado !== "") {
    params.Estado = filters.Estado;
  }
  const { data } = await apiClient.get("cursos", { params, skipAuth: true });
  return data;
};

export const getCursosActivosConPreguntas = async () => {
  const { data } = await apiClient.get("cursos/activos-con-preguntas");
  return data;
};

export const getCurso = async (idCurso) => {
  const { data } = await apiClient.get(`cursos/${idCurso}`);
  return data;
};

export const getSeccionesCurso = async (idCurso) => {
  const { data } = await apiClient.get(`cursos/${idCurso}/secciones`);
  return data;
};

/**
 * Obtiene preguntas sugeridas por IA a partir del resumen de los PDFs del curso.
 * Respuesta: { idCurso, preguntas: [{ pregunta, descripcion, tipo, opciones: [{respuesta, correcta}] }] }
 */
export const getPreguntasSugeridas = async (idCurso) => {
  const { data } = await apiClient.get(`cursos/${idCurso}/preguntas-sugeridas`);
  return data;
};

export const registrarInicioCurso = async (idCurso) => {
  const { data } = await apiClient.post(`cursos/${idCurso}/inicio`, {});
  return data;
};

export const registrarFinalizacionCurso = async (idCurso, payload) => {
  const { data } = await apiClient.post(`cursos/${idCurso}/finalizacion`, payload);
  return data;
};

export const updateCurso = async (idCurso, payload) => {
  const { data } = await apiClient.put(`cursos/${idCurso}`, payload);
  return data;
};

/**
 * Sube la imagen de portada del curso (multipart, campo `portada`).
 * Ver Swagger: POST /cursos/{id}/portada — máx. ~5 MB, JPEG/PNG/WebP/GIF.
 */
export const uploadCursoPortada = async (idCurso, file) => {
  const formData = new FormData();
  formData.append("portada", file, file.name);
  const { data } = await apiClient.post(`cursos/${idCurso}/portada`, formData);
  return data;
};

/**
 * Crea una sección del curso con nombre, orden, estado y archivo PDF.
 * @param {number} idCurso - ID del curso
 * @param {{ nombre: string, orden: number, estado: number, archivo: File }} payload
 */
export const createSeccion = async (idCurso, { nombre, orden, estado, archivo }) => {
  const formData = new FormData();
  // La API espera PascalCase (igual que en createCurso: Nombre, Estado)
  formData.append("Nombre", nombre.trim());
  formData.append("Orden", String(orden));
  formData.append("Estado", String(estado));
  if (archivo) formData.append("archivo", archivo, archivo.name);
  const { data } = await apiClient.post(`cursos/${idCurso}/secciones`, formData);
  return data;
};

export const updateSeccion = async (idCurso, idSeccion, { nombre, orden, estado, archivo }) => {
  if (archivo) {
    const formData = new FormData();
    formData.append("Nombre", (nombre || "").trim());
    formData.append("Orden", String(orden ?? 1));
    formData.append("Estado", String(estado ?? 1));
    formData.append("archivo", archivo, archivo.name);
    // Backend contract: con archivo usa POST multipart a la ruta de update.
    const { data } = await apiClient.post(`cursos/${idCurso}/secciones/${idSeccion}`, formData);
    return data;
  }

  const payload = {
    Nombre: (nombre || "").trim(),
    Orden: orden ?? 1,
    Estado: estado ?? 1,
  };
  const { data } = await apiClient.put(`cursos/${idCurso}/secciones/${idSeccion}`, payload);
  return data;
};

export const deleteSeccion = async (idCurso, idSeccionCurso) => {
  const { data } = await apiClient.put(
    `cursos/${idCurso}/secciones/${idSeccionCurso}/eliminar`,
    {}
  );
  return data;
};

export const getSeccionPdfDownloadUrl = (idCurso, archivoUrl) => {
  const base = `${API_BASE_URL}${API_PREFIX ? `/${API_PREFIX}` : ""}`.replace(/\/+$/, "");
  const archivo = String(archivoUrl || "").trim();
  if (!idCurso || !archivo) return "";
  return `${base}/cursos/${idCurso}/secciones/descargar?archivoUrl=${encodeURIComponent(archivo)}`;
};

